import React from 'react'
import Modal from 'react-modal';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import '../../css/react-datepicker.css';
import { insertLeave } from '../../actions/leaveAction'
import Switch from "react-switch";
import moment from 'moment'

class AddLeaveModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leaveId: this.props.leaveItem.length == 0 ? '' : this.props.leaveItem[0].LeaveId,
            employeeId: this.props.leaveItem.length == 0 ? '' : this.props.leaveItem[0].EmployeeId,
            leaveFromDate: this.props.leaveItem.length == 0 ? new Date() : new Date(this.props.leaveItem[0].LeaveDate),
            leaveToDate: new Date(),
            leaveType: this.props.leaveItem.length == 0 ? 'CL' : this.props.leaveItem[0].LeaveType,
            leaveCount: this.props.leaveItem.length == 0 ? '1.0' : this.props.leaveItem[0].LeaveCount == '0.5' ? this.props.leaveItem[0].IsSecondHalf == false ? 'firstHalf' : 'SecondHalf' : this.props.leaveItem[0].LeaveCount,
            remarks: this.props.leaveItem.length == 0 ? '' : this.props.leaveItem[0].Remarks == null ? '' : this.props.leaveItem[0].Remarks,
            IsApproved: this.props.leaveItem.length == 0 ? false : this.props.leaveItem[0].IsApproved,
            IsSecondHalf: this.props.leaveItem.length == 0 ? false : this.props.leaveItem[0].IsSecondHalf,
            errors: {},
        }
        this.fromDateChange = this.fromDateChange.bind(this);
        this.toDateChange = this.toDateChange.bind(this);
    }


    fromDateChange(dt) {
        this.setState({
            leaveFromDate: dt,
            leaveToDate: dt
        });
    }

    toDateChange(date) {
        this.setState({
            leaveToDate: date
        });
        this.handleValidation();
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        if (this.handleValidation()) {
            var selectedValue = document.getElementById("ComboBoxLeaveCount").value;
            if (selectedValue == 'firstHalf' || selectedValue == 'SecondHalf') {
                this.state.leaveCount = 0.5;
            }
            if (selectedValue == 'firstHalf') {
                this.state.IsSecondHalf = 0
            }
            if (selectedValue == 'SecondHalf') {
                this.state.IsSecondHalf = 1
            }
            await insertLeave(this.state);
            this.props.refreshData();
            this.props.toggle()
        }
    }

    handleValidation = () => {
        var validToDate = moment(this.state.leaveToDate).isSameOrAfter(this.state.leaveFromDate)
        let formIsValid = true;
        let errors = {};
        if (!validToDate) {
            formIsValid = false;
            errors["validDate"] = "Invalid To Date."
        }
        this.setState({ errors: errors });
        return formIsValid
    }


    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }
    toggleModal() {
        this.props.toggle();
    }

    handleSwitch = (checked) => {
        this.setState({ IsSecondHalf: checked });
    }


    render() {



        return (
            <>
                <Modal isOpen={this.props.isOpen} onAfterOpen={this.afterOpenModal} onRequestClose={this.toggleModal} ariaHideApp={false} className='modal-style' contentLabel="">
                    <div id='addLeaveModal' className={'v-modal-transparet-header'}>
                        <div className={'modal fade-in'} style={{ display: 'block' }}>
                            <div className={'modal fade-in'} style={{ display: 'block' }}>

                                <form onSubmit={this.handleSubmit} >
                                    <div className={'modal-dialog modal-lg modal-wd95pc-mwd-618'} style={{ margin: '8.75rem 48.75rem' }}>
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 style={{ marginRight: "auto" }}  ><i className='fa fa-plus-square-o'></i>  Add Leave</h4>
                                                <div className='inline-block right pdT9'><span id='spnCancel' className='cursor-pointer v-bold' onClick={() => { this.props.toggle(); }}>X</span></div>
                                            </div>
                                            <div className="modal-body leave-modal">
                                                <div className="form-horizontal">
                                                    <div className="row">
                                                        <label className="col-sm-4">{this.props.leaveItem.length != 0 && <p>Leave Date</p>} {this.props.leaveItem.length == 0 && <p>From Date</p>} </label>
                                                        <div className="col-sm-8" id="LeaveDateFrom">
                                                            <DatePicker className='form-control' selected={new Date(this.state.leaveFromDate)}
                                                                onChange={this.fromDateChange}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="MM/DD/YYYY" />
                                                        </div>
                                                    </div>
                                                    <br />
                                                    {this.props.leaveItem.length == 0 && <div className="row">
                                                        <label className="col-sm-4 control-label">To Date</label>
                                                        <div className="col-sm-8" id="LeaveDateTo">
                                                            <DatePicker className='form-control' selected={new Date(this.state.leaveToDate)}
                                                                onChange={this.toDateChange}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="MM/DD/YYYY" />
                                                            <span style={{ color: "red" }}>{this.state.errors["validDate"]}</span>
                                                        </div>
                                                    </div>
                                                    }
                                                    {this.props.leaveItem.length == 0 && <br />}
                                                    <div className="row">
                                                        <label className="col-sm-4 control-label">Leave Type</label>
                                                        <div className="col-sm-8">
                                                            <select id="ComboBoxLeaveType" onChange={this.handleChange} value={this.state.leaveType} name="leaveType" className="form-control">
                                                                <option value="CL">Casual Leave</option>
                                                                <option value="SL">Sick Leave</option>
                                                                <option value="EL">Earned Leave</option>
                                                                <option value="EW">Extra Work</option>
                                                                <option value="LWP">Leave Without Pay</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div className="row">
                                                        <label className="col-sm-4 control-label">Period</label>
                                                        <div className="col-sm-8">
                                                            <select id="ComboBoxLeaveCount" onChange={this.handleChange} value={this.state.leaveCount} name="leaveCount" className="form-control">
                                                                <option value="1.0">Full Day</option>
                                                                <option value="firstHalf">First Half</option>
                                                                <option value="SecondHalf">Second Half</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    {this.state.leaveCount == '0.5' && <div className="row" style={{ display: 'none' }}>
                                                        <label className="col-sm-4 control-label">Second Half</label>
                                                        <div className="col-sm-8">
                                                            <Switch onChange={this.handleSwitch} checked={this.state.IsSecondHalf}
                                                                onColor="#b2ec5c"
                                                                checkedIcon={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 15, color: "orange", paddingRight: 2 }}>On</div>}
                                                                uncheckedIcon={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 15, color: "orange", paddingRight: 2, }}>off</div>} />
                                                        </div>
                                                    </div>}
                                                    <br />
                                                    <div className="row">
                                                        <label className="col-sm-4 control-label">Remark</label>
                                                        <div className="col-sm-8">
                                                            <input type="text" id="TextAreaLeaveRemark" value={this.state.remarks} name="remarks" onChange={this.handleChange} className="form-control" />
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <input type='submit' className="btn btn-success" value='OK' />
                                                <button className="btn btn-default" style={{ borderColor: '#ccc' }} onClick={() => { this.props.toggle() }} type='button' title="Cancel">Cancel</button>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default AddLeaveModal
